export default __webpack_public_path__ + "static/media/1019.076c6be1.png";